// extracted by mini-css-extract-plugin
export default {"closeButtonStyle":"MenuCartBarHeader_closeButtonStyle__s+6Qo","colorVoiletGgray":"MenuCartBarHeader_colorVoiletGgray__vPO6a"};